import { useEffect, useState } from "react";
import { sortSavedQuestions } from "@markit/common.utils";
import { SavedFormQuestion } from "@markit/common.types";
import { useSelector } from "react-redux";
import { getAccountState } from "../redux/slices/accountSlice";
import { getNumSavedQuestionResponses } from "../utils/eventUtils/formUtils";

// Not the traditional useLoad hook
// Simply fetches the number of responses for all saved questions
export const useLoadDataQuestionNumResponses = () => {
  const { savedQuestions, accountData } = useSelector(getAccountState).account;
  const [savedQuestionsToShow, setSavedQuestionsToShow] = useState<
    SavedFormQuestion[]
  >([]);
  const [savedQuestionDetails, setSavedQuestionDetails] = useState<
    Map<string, number>
  >(new Map()); // question id -> num responses
  const [isLoading, setIsLoading] = useState(false);

  // Keep these up to date if any new questions are added
  useEffect(() => {
    const sortedQuestions = sortSavedQuestions(savedQuestions, [], []);
    setSavedQuestionsToShow(sortedQuestions);
  }, [savedQuestions]);

  const loadSavedQuestionDetails = async () => {
    setIsLoading(true);
    const sortedSavedQuestions = sortSavedQuestions(savedQuestions, [], []);
    setSavedQuestionsToShow(sortedSavedQuestions);

    await Promise.all(
      sortedSavedQuestions.map(async (item) => {
        const numberOfResponses = await getNumSavedQuestionResponses(
          accountData.uid,
          item.id
        );
        setSavedQuestionDetails((prevDetails) => {
          const newDetails = new Map(prevDetails);
          newDetails.set(item.id, numberOfResponses);
          return newDetails;
        });
      })
    );
    setIsLoading(false);
  };

  return {
    savedQuestionsToShow,
    savedQuestionDetails,
    isLoading,
    loadSavedQuestionDetails,
  };
};
